import { render, staticRenderFns } from "./wordreading.config.vue?vue&type=template&id=f3f72a8c"
import script from "./wordreading.config.vue?vue&type=script&lang=js"
export * from "./wordreading.config.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../app/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports